import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';

interface LoadingWrapperProps {
  isLoading: boolean;
  children?: React.ReactNode;
  message?: string;
  minHeight?: number | string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = (props) => {
  let { isLoading, children, message = 'Loading...', minHeight = 300 } = props;

  if (isLoading) {
    return (
      <Fade in={true} timeout={300}>
        <Box
          sx={{
            width: '100%',
            minHeight,
            backgroundColor: '#f1f1f1',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
          }}
        >
          <CircularProgress size={56} thickness={3.6} sx={{ color: 'primary.main' }} />
          <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500, letterSpacing: '0.02em', fontSize: '0.95rem' }}>
            {message}
          </Typography>
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={true} timeout={300}>
      <Box>{children}</Box>
    </Fade>
  );
};

export default LoadingWrapper;
